import { render, staticRenderFns } from "./portsArchive.vue?vue&type=template&id=7bcad1cd"
import script from "./portsArchive.vue?vue&type=script&lang=js"
export * from "./portsArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports